import React from "react";
import { Layout, Row, Col, Form, Input, Button, message, Typography } from "antd";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import incrementarventas from "../../assets/incrementaventas.png";
import "./CustomFooter.scss";
const { Footer } = Layout;
const { Title, Text } = Typography;

const CustomFooter = () => {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const data = {
        comentarios: values.comentarios,
        email: values.email,
        telefono: values.telefono,
        revisado: false,
      };
      await addDoc(collection(db, "ApoyoNuevaCuenta"), data);
      message.success("¡Consulta enviada con éxito!");
      form.resetFields();
    } catch (error) {
      message.error("Error al enviar la consulta.");
    }
  };

  return (
    <Footer className="blizu-footer-global">
      <div className="footer-content-wrapper">
        
        {/* SECCIÓN PROVEEDORES (FORMULARIO) */}
        <div className="provider-section">
          <Title level={2} className="white-text">¿Quieres vender en Blizu?</Title>
          <Text className="white-text subtitle">
            Descubre los beneficios de publicar tus servicios. Déjanos tus datos y te contactamos.
          </Text>

          <Row gutter={[32, 32]} align="middle" className="form-row-container">
            <Col xs={0} md={12} className="img-container">
              <img src={incrementarventas} alt="Ventas" className="footer-promo-img" />
            </Col>
            <Col xs={24} md={12}>
              <Form form={form} layout="vertical" onFinish={onFinish} className="footer-form-style">
                <Form.Item name="email" label={<span className="label-white">Correo</span>} rules={[{ required: true, type: 'email' }]}>
                  <Input placeholder="tu-email@ejemplo.com" />
                </Form.Item>
                <Form.Item name="telefono" label={<span className="label-white">Teléfono</span>} rules={[{ required: true }]}>
                  <Input placeholder="+52 123 456 7890" />
                </Form.Item>
                <Form.Item name="comentarios" label={<span className="label-white">Comentarios</span>} rules={[{ required: true }]}>
                  <Input.TextArea rows={3} placeholder="Dudas o comentarios..." />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" block className="blizu-btn">
                    Enviar solicitud
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>

        <div className="footer-divider" />

        {/* SECCIÓN DISTINTIVA (ENLACES Y CONTACTO) */}
        <div className="legal-and-contact">
          <Row gutter={[16, 24]} justify="center" style={{ textAlign: "center" }}>
            <Col xs={24} className="links-col">
              <a href="/terminos-condiciones">Términos y condiciones</a>
              <span className="separator">|</span>
              <a href="/declaracion-privacidad">Privacidad y confidencialidad</a>
              <span className="separator">|</span>
              <a href="/terminos-vendedor">Términos del vendedor</a>
            </Col>

            <Col xs={24} className="address-col">
              <p>Av. Juan Rulfo 1851 – 69 Fracc. Sonterra, C.P 76235, Querétaro, México.</p>
            </Col>

            <Col xs={24} md={8} className="contact-item">
              <strong>CONTACTO</strong>
              <p>ayuda@blizu.com.mx</p>
              <p>+52 1 442 345 9936</p>
            </Col>

            <Col xs={24} className="copyright-col">
              <p>Blizu © 2026. Operado por BLISHOP TECH SERVICES S.A.P.I. DE C.V. Todos los derechos reservados.</p>
            </Col>
          </Row>
        </div>
      </div>
    </Footer>
  );
};

export default CustomFooter;